<template>
  <div class="btn-wrapper d-flex">
    <router-link
      @click.capture="goToPayment"
      :to="{ name: routerName }"
      class="go-back w-40"
    >
      <span class="d-flex cursor-pointer">
        <img src="@/assets/img/back.svg" alt="back">
        {{ $t('go-back') }}
      </span>
    </router-link>
  </div>
</template>

<script>
import { USER_TRACK_EVENTS } from '../store/modules/user/consts';

export default {
  props: {
    routerName: String,
    extraData: String,
  },
  methods: {
    goToPayment() {
      if (this.extraData === '1') {
        this.$DbStorage.setItem('rocketfuel_connect_bank', 1);
      }
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: this.$route.name,
          activity: 'Click on Router Button',
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.go-back {
  color: #000000;
  font-size: 16px;
  font-weight: 500;
  span {
    justify-content: center;
    img {
      width: 10px;
      margin-right: 10px;
    }
  }
  &:hover {
    color: #222641;
    text-decoration: none;
  }
}
.btn-wrapper {
  text-align: center;
}
</style>
